export default __webpack_public_path__ + "static/media/teal@2x.e0278fe4.png";